import { useEffect } from 'react'
import { Container, Box, CircularProgress, Typography } from '@mui/material'
import { logout } from '../services/salesforce'

export default function LogoutPage() {
  useEffect(() => {
    // ログアウト処理
    // logout()内でSalesforceのログアウトページにリダイレクトされる
    logout()
  }, [])

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6">Salesforceからログアウト中...</Typography>
        <Typography variant="body2" color="text.secondary">
          ログアウト後、再度ログインしてください
        </Typography>
      </Box>
    </Container>
  )
}
